export const pt = {
  "common.signOut": "Sair",
  "common.loginRegister": "Entrar / Cadastrar",
  "common.follow": "Siga {brand}",
  "common.superAdmin": "● Super Admin",
  "common.viewer": "● Visualizador",
  "common.language": "Idioma",

  "lock.unlock": "Desbloquear",
  "lock.locked": "Bloqueado",

  "nav.database": "Banco de Dados ECU",
  "nav.software": "Galeria de Software",
  "nav.binConverter": "Converter",
  "nav.checksum": "Checksum",
  "nav.fileService": "Serviço de Arquivos",
  "nav.pinout": "Pinagem ECU",
  "nav.xdfAdx": "Desbloqueio XDF / ADX",
  "nav.immo": "IMMO Service",
  "nav.recovery": "Gerador de Recovery",
  "nav.mapEditor": "Map Editor",
  "nav.hondaFlashtools": "Honda Flash Tools",
  "nav.yamahaFlashtools": "Yamaha Flash Tools",
  "nav.autoMapFinder": "Localizador Automático de Mapas",
  "nav.seedKey": "Visualizar Seed Key",
  "nav.diagram": "Ferramenta de Diagramas",
  "nav.desktopApp": "App Desktop",
  "nav.ecuDatabaseAdmin": "Update Info Bike",
  "nav.ecuLibrary": "Update Basemap",
  "nav.userControl": "Controle de Usuários",
  "nav.appUpdate": "Atualização do App",

  "guard.flashing": "Gravação em andamento — não é possível sair. Pressione Abort e depois Disconnect primeiro.",
  "guard.leave": "O Editor de Mapas está bloqueado — edições não salvas, Flash Tools ativo ou um dispositivo FTDI ainda conectado.\n\nSair da página? Alterações não salvas podem ser perdidas.",

  "mapeditor.narrowbandNote": "O2 narrowband: mais preciso em torno de 14,7 (marcha lenta/cruzeiro). Correção limitada a ±{step}% por célula. Grave enquanto pilota para que cada área RPM×TPS receba amostras.",
  "mapeditor.noSamples": "Ainda sem amostras ao vivo. Ative Live e depois Record enquanto pilota.",

  "login.tagline": "Remapeamento de ECU",
  "login.tabLogin": "Entrar",
  "login.tabRegister": "Cadastrar",
  "login.name": "Nome",
  "login.phone": "Telefone",
  "login.email": "E-mail",
  "login.country": "País",
  "login.password": "Senha",
  "login.confirm": "Repita a Senha",
  "login.submitLogin": "Entrar",
  "login.submitRegister": "Criar Conta",
  "login.forgotQ": "Esqueceu a senha?",
  "login.forgotAction": "Redefinir via admin",
  "login.forgotHint": "Informe o Nome, E-mail e Telefone da sua conta. O admin verificará e entrará em contato com sua senha.",
  "login.forgotSubmit": "Enviar Solicitação ao Admin",
  "login.pendingTitle": "Aguardando aprovação do admin",
  "login.pendingBody": "A conta {email} foi criada. Você poderá entrar assim que um admin aprovar.",
  "login.backToLogin": "Voltar ao Login",
  "login.toastSuccess": "Login realizado com sucesso",
  "login.toastPwMismatch": "A senha e a confirmação não coincidem",
  "login.toastRegistered": "Conta criada — aguardando aprovação do admin",
  "login.toastForgotFill": "Preencha pelo menos Nome e E-mail",
  "login.toastForgotSent": "Solicitação enviada ao admin",
  "login.err": "Algo deu errado. Tente novamente.",
};
